import React from "react";
import { useTranslation } from "react-i18next";

interface WizardTimelineProps {
  steps: string[];
  currentStep: number;
}

export const WizardTimeline: React.FC<WizardTimelineProps> = ({ steps, currentStep }) => {
  const { t } = useTranslation();
  
  return (
    <div className="flex w-full items-center">
      {steps.map((step, index) => (
        <div key={index} className="flex items-center flex-1">
          <div className={`flex-shrink-0 h-8 w-8 flex items-center justify-center rounded-sm border ${
            index < currentStep ? 'bg-blue-500 text-white border-blue-500' : 
            index === currentStep ? 'border-blue-500 text-blue-500' : 
            'border-gray-300 text-gray-400'
          }`}>
            {index < currentStep ? (
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            ) : (
              <span>{index + 1}</span>
            )}
          </div>
          {index < steps.length - 1 && (
            <div className={`flex-1 h-1 ${index < currentStep ? 'bg-blue-500' : 'bg-gray-300'}`}></div>
          )}
          {index > 0 && index === steps.length - 1 && (
            <div className="flex-1"></div>
          )}
        </div>
      ))}
    </div>
  );
};
